<template>
  <div class="update-accessory-modal">
    <el-button type="primary" @click="openModal">{{ !orderAccessoryDelivery ? '新建辅料' : '编辑辅料' }}</el-button>

    <el-dialog class="update-accessory-modal" :title="!orderAccessoryDelivery ? '新建辅料' : '编辑辅料'" :visible.sync="modalVisible" width="90%" append-to-body fullscreen @open="handleOpen">
      <el-form label-position="top">
        <el-form-item prop="accessories" label="辅料">
          <div class="admin-form-upload">
            <ResourceUploader
              :limit="uploadLimit"
              accept="image/*"
              :size="3"
              :disabled="uploadLimit < 1"
              @success="handleUploadSuccess"
              v-model="uploadDisalogVisible"
            />

            <el-button
              type="primary"
              icon="el-icon-plus"
              :disabled="uploadLimit < 1"
              @click="uploadDisalogVisible = true"
            >{{ $t('bean.actionUpload') }}</el-button>

            <draggable
              v-model="accessories"
              class="resource-content"
              v-if="accessories.length"
            >
              <template v-for="(item, index) in accessories">
                <div class="item-resource" :key="index">
                  <el-button v-if="item.image.url" size="mini" circle class="btn-close" icon="el-icon-delete" @click.stop="handleDelete(index)"></el-button>
                  <bean-resource-render :value="item.image" type="image" />
                </div>
              </template>
            </draggable>
            <div v-if="accessories.length > 1" class="drag-tip">{{ $t('bean.dragSort') }}</div>
          </div>
        </el-form-item>

        <el-form-item prop="line_items" label="订单项">
          <el-table show-summary :data="tableData" border style="width: 100%" :key="tableKey">
            <el-table-column min-width="100" prop="color_option_value.name" label="颜色" />
            <el-table-column min-width="100" prop="size_option_value.name" label="尺寸" />
            <el-table-column min-width="100" prop="quantity" label="数量" />
            <el-table-column min-width="160" v-for="(item, index) in accessories" :key="index" :prop="`accessory-${index}-quantity`">
              <template #header>
                <el-image style="width: 60px; height: 60px" :src="item.image.url" :preview-src-list="[item.image.url]" />
                <el-input size="small" v-model="accessories[index].name" placeholder="辅料名称"></el-input>
              </template>
              <template #default="scope">
                <el-input
                  size="small"
                  type="number"
                  :value="get(item.quantity, scope.$index)"
                  @input="handleQuatityInput(index, scope.$index, $event)"
                ></el-input>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="modalVisible = false">取 消</el-button>
        <el-button type="primary" :loading="loading" @click="handleSubmit">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import ResourceUploader from 'beans-admin-plugin/components/upload/resource-uploader';
import draggable from 'vuedraggable';
import _ from 'lodash';
import { getTableData } from './line-item-accessories.vue';

@Component({
  components: {
    ResourceUploader,
    draggable,
  }
})
export default class UpdateAccessoryModal extends Vue {
  @Prop({ type: Function }) submitHandler;
  @Prop({ type: Array, default: () => [] }) lineItems;
  @Prop({ type: Object }) orderAccessoryDelivery;

  get = _.get;
  modalVisible = false;
  loading = false;
  uploadDisalogVisible = false;

  accessories = [];

  get tableKey() {
    return (this.accessories || []).map(item => item.id).join(',');
  }

  get uploadLimit() {
    return 20 - (this.accessories || []).length;
  }

  get lineItemsWithAccessories() {
    return (this.lineItems || []).map((item, rowIndex) => {
      return {
        ...item,
        line_item_accessories: this.accessories.map((accessory) => {
          return {
            quantity: +_.get(accessory, `quantity.${rowIndex}`) || null
          };
        })
      }
    });
  }

  get tableData() {
    return getTableData(this.lineItemsWithAccessories, this.accessories);
  }

  handleOpen() {
    if (this.orderAccessoryDelivery) {
      this.accessories = (this.orderAccessoryDelivery.accessories || []).map((accessory) => {
        return {
          ...accessory,
          quantity: this.lineItems.map(lineItem => {
            const orderAccessoryDeliveryItem = (this.orderAccessoryDelivery.order_accessory_delivery_items || []).find(item => item.accessory_id === accessory.id && item.line_item_id === lineItem.id);
            return orderAccessoryDeliveryItem ? orderAccessoryDeliveryItem.quantity : null;
          })
        }
      })
    }
  }

  openModal() {
    this.modalVisible = true;
  }

  async handleSubmit() {
    if (this.submitHandler) {
      this.loading = true;
      try {
        const body = {
          line_items: this.lineItemsWithAccessories,
          accessories: this.accessories.map(item => {
            return {
              ..._.omit(item, 'quantity'),
              image: item.image.signed_id,
            }
          })
        }
        await this.submitHandler(body);
        this.modalVisible = false;
      } finally {
        this.loading = false;
      }
    }
  }

  handleQuatityInput(imageIndex, rowIndex, value) {
    this.$set(this.accessories[imageIndex].quantity, rowIndex, value);
  }

  handleUploadSuccess(images) {
    this.accessories = this.accessories || [];
    this.accessories.push(...images.map((image, index) => ({ image, quantity: [], name: `辅料${this.accessories.length + index + 1}` })));
  }

  handleDelete(index) {
    this.accessories.splice(index, 1);
  }
}
</script>

<style lang="scss">
.update-accessory-modal {
  .el-dialog {
    display: flex;
    flex-direction: column;
  }

  .el-dialog__body {
    flex: 1;
    max-height: unset;
    overflow: auto;
  }

  .el-dialog__header,
  .el-dialog__footer {
    flex-shrink: 0;
  }
}
</style>
